import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ConfigReportListState,
  Signal,
} from "../../../../utils/interfaces/store/IStore";
import { ConfigReport } from "../../../../utils/types/ConfigReport";
import { IPayloadSetError } from "../../../Interfaces";

const initialState: ConfigReportListState = {
  configReports: Signal.default(),
  rows: [],
  search: "",
  page: 0,
  rowsPerPage: 10,
};

export const ConfigReportListSlice = createSlice({
  name: "ConfigReportList",
  initialState,
  reducers: {
    clean: (_, action: PayloadAction<undefined>) => {
      return {
        ...initialState,
        action: { ...action } as any,
      } as ConfigReportListState;
    },
    setSearch: (state, action: PayloadAction<string | undefined>) => {
      return {
        ...state,
        action: { ...action } as any,
        search: action.payload ?? "",
        rows: state.configReports?.value?.filter(
          (x) =>
            x?.name
              ?.toLowerCase()
              .includes(action.payload?.toLowerCase() ?? "") ||
            x?.description
              ?.toLowerCase()
              .includes(action.payload?.toLowerCase() ?? "")
        ),
      } as ConfigReportListState;
    },
    setPage: (state, action: PayloadAction<number>) => {
      return {
        ...state,
        action: { ...action } as any,
        page: action.payload,
      } as ConfigReportListState;
    },
    setRowPerPage: (state, action: PayloadAction<number>) => {
      return {
        ...state,
        action: { ...action } as any,
        rowsPerPage: action.payload,
      } as ConfigReportListState;
    },
    getAll: (state, action: PayloadAction<undefined>) => {
      return {
        ...state,
        action: { ...action } as any,
        configReports: Signal.loading(),
      } as ConfigReportListState;
    },
    getAllSuccess: (state, action: PayloadAction<ConfigReport[]>) => {
      return {
        ...state,
        action: { ...action } as any,
        configReports: Signal.success(action.payload),
        rows: [...action.payload],
      } as ConfigReportListState;
    },
    getAllError: (state, action: PayloadAction<IPayloadSetError>) => {
      return {
        ...state,
        action: { ...action } as any,
        configReports: Signal.error(
          action.payload.error,
          action.payload.shorterror
        ),
      } as ConfigReportListState;
    },
    delete: (state, action: PayloadAction<undefined>) => {
      return {
        ...state,
        action: { ...action } as any,
      } as ConfigReportListState;
    },
    deleteSuccess: (state, action: PayloadAction<string>) => {
      const result = state.configReports?.value?.filter(
        ({ id }) => id !== action.payload
      ) as ConfigReport[];

      return {
        ...state,
        action: { ...action } as any,
        configReports: Signal.success([...result]),
        rows: [...result],
      } as ConfigReportListState;
    },
    deleteError: (state, action: PayloadAction<IPayloadSetError>) => {
      return {
        ...state,
        action: { ...action } as any,
        configReports: Signal.error(
          action.payload.error,
          action.payload.shorterror
        ),
      } as ConfigReportListState;
    },
  },
});
